import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const subSkuApi = createApi({
  reducerPath: "subSkuApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["subSku"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getSubSku: builder.query({
      query: ({ search }) => {
        const params = new URLSearchParams();
        console.log(search);
        if (search && search.length > 0) {
          params.set("search", search);
        }
        return `/subSku?${params.toString()}`;
      },
      providesTags: ["subSku"],
    }),
    getSubSkuById: builder.query<any, any>({
      query: ({ id }) => `/subSku/${id}`,
      providesTags: ["subSku"],
    }),
    createSubSku: builder.mutation<void, any>({
      query: (input) => ({
        url: `/subSku`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["subSku"],
    }),
    getSubSkuBySkuId: builder.query<any, any>({
      query: ({ id }) => `/subSku/sku/${id}`,
      providesTags: ["subSku"],
    }),
    updateSubSku: builder.mutation<void, any>({
      query: ({ id, data }) => ({
        url: `/subSku/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["subSku"],
    }),
    deleteSubSku: builder.mutation<void, any>({
      query: ({ id }) => ({
        url: `/subSku/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["subSku"],
    }),
  }),
});

export const {
  useCreateSubSkuMutation,
  useDeleteSubSkuMutation,
  useGetSubSkuByIdQuery,
  useGetSubSkuQuery,
  useUpdateSubSkuMutation,
  useGetSubSkuBySkuIdQuery,
} = subSkuApi;
